<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-simple-table dense style="border: 1px solid #d1d1d1">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left caption">GRUPO PADRE</th>
                <th class="text-left caption">TOTAL GRUPO PADRE</th>
                <th class="text-left caption">GRUPO</th>
                <th class="text-right caption">TOTAL GRUPO</th>
              </tr>
            </thead>

            <tbody>
              <template v-for="presupuesto in presupuestosAgrupados">
                <tr v-for="(grupo, index) in presupuesto.grupos" :key="grupo.codigo_grupo">
                  <td v-if="index == 0" :rowspan="presupuesto.grupos.length" class="text-left caption">
                    {{ presupuesto.codigo_grupo_padre }} {{ presupuesto.grupo_padre }}
                  </td>
                  <td v-if="index == 0" :rowspan="presupuesto.grupos.length" class="text-right caption">
                    {{ formatearNumero(presupuesto.grupos.reduce((a, b) => a + Number(b.total_grupo), 0).toFixed(2)) }}
                  </td>
                  <td class="text-left caption">{{ grupo.codigo_grupo }} {{ grupo.grupo }}</td>
                  <td class="text-right caption">{{ formatearNumero(grupo.total_grupo) }}</td>
                </tr>
              </template>

              <tr>
                <td colspan="3" class="text-left caption">TOTAL</td>
                <td class="text-right caption">
                  {{ formatearNumero(presupuestos.reduce((a, b) => a + Number(b.total_grupo), 0).toFixed(2)) }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { formatearNumero } from './../utils.js';

export default {
  name: 'TablaGastosPorGrupo',
  props: {
    presupuestos: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    presupuestosAgrupados() {
      const presupuestosAgrupados = {};

      this.presupuestos.forEach((presupuesto) => {
        if (!presupuestosAgrupados[presupuesto.codigo_grupo_padre]) {
          presupuestosAgrupados[presupuesto.codigo_grupo_padre] = {
            codigo_grupo_padre: presupuesto.codigo_grupo_padre,
            grupo_padre: presupuesto.grupo_padre,
            total_grupo_padre: 0,
            grupos: [],
          };
        }

        presupuestosAgrupados[presupuesto.codigo_grupo_padre].grupos.push({
          codigo_grupo: presupuesto.codigo_grupo,
          grupo: presupuesto.grupo,
          total_grupo: Number(presupuesto.total_grupo),
        });

        presupuestosAgrupados[presupuesto.codigo_grupo_padre].total_grupo_padre += Number(presupuesto.total_grupo);
      });

      return presupuestosAgrupados;
    },
  },
  methods: {
    formatearNumero,
  },
};
</script>